import { useCallback } from "react";

import {
    ACCESS_TOKEN_LOCAL_STORAGE_KEY,
    REFRESH_TOKEN_LOCAL_STORAGE_KEY,
    SUBBUSINESS_ID_LOCAL_STORAGE_KEY,
    CONFIG_STORAGE_KEY
} from "core/common/constants/localstorage";

import { navigate } from "raviger";
import { setReturnUrl } from "core/route/index";
import useAppInitialData from "core/custom-hooks/useAppInitialData";
import useStore from "core/custom-hooks/useStore";
import useLogout from "core/custom-hooks/useLogout";

import { resetStore, setIsAdmin } from "../../core/store/actionCreators";

import useJwtTokenData from "core/custom-hooks/useJwtTokenData";
import routes from "core/route";
import { isPreAuthenticationPath } from "core/route/index";
import * as TagManager from "core/common/seo/tagManager";
import { HasRefreshToken } from "../common/utils";

const useProtectRoutes = () => {

    const { dispatch, state } = useStore();
    const { recaptchaRef } = state.recaptcha;
    const { handleLogout } = useLogout();

    const { getAppInitialData } = useAppInitialData();
    const { hasAdminRole } = useJwtTokenData();
    const { business, lookup, isLoading } = state;
    const adminAccountSelectionPath = "/admin-account-selection";
    /**
     * This is the protect routes call back
     * when the user  will try to access to a route which requires login
     * and the user is not logged in or the token has expired
     * we will redirect the user to the login page
     */

    const handleAdminRole = () => {
        const { isAdmin } = state;

        if (typeof (isAdmin) !== "boolean") {
            const admin = sessionStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY) && hasAdminRole();
            dispatch(setIsAdmin(admin));
            return admin;
        }

        return isAdmin;
    };

    //const handleNoToken = (path) => {
    //    dispatch(resetStore());

    //    sessionStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
    //    localStorage.removeItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
    //    localStorage.removeItem(CONFIG_STORAGE_KEY);

    //    setReturnUrl(path);
    //};

    const handleAdminRoute = (path, admin) => {

        if (path !== adminAccountSelectionPath) {

            const noSubBuisinessSelected = !localStorage.getItem(SUBBUSINESS_ID_LOCAL_STORAGE_KEY);
            if (admin && noSubBuisinessSelected) {

                navigate(adminAccountSelectionPath);

                return true;
            }
        }
    };

    const handleInitialData = () => {
        if (!isLoading && [business, lookup].some(x => !x)) {
            getAppInitialData();
        }
    };

    const migrateAccessToken = () => {
        const sessionToken = sessionStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        const localToken = localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        if (!sessionToken && localToken) {
            sessionStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, localToken);
        }
        if (localToken) {
            localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        }
    };
    const handleRouteChange = useCallback(async (location) => {
        // Migrate access token from localStorage to sessionStorage for old users
        migrateAccessToken();

        //get params from Branch.io
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page') || "";

        const pagePath = page ? `/${page}` : location.fullPath; 

        const hasToken = !!sessionStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);

        const isProtectedPath = !isPreAuthenticationPath(pagePath);
        recaptchaRef?.reset();

        if (isProtectedPath && !HasRefreshToken()) {
            handleLogout();
        }

        if (isProtectedPath && !hasToken) {

            //handleNoToken(pagePath);

            //console.debug("handle no token");

            //handleLogout();

            return;
        }

        if (hasToken && !isProtectedPath && ![adminAccountSelectionPath, "/login"].includes(pagePath)) {
            return navigate(page ? `/${page}` : "/home");
        }

        const basePath = '/' + ((pagePath || '').split('/')[1] || ''); // i.e. '/galleries' from '/galleries/image'
        // redirect if route not exists, e.g. '/galleries' needs to be ok since '/galleries*' is in the routes
        if (!routes[pagePath] && !Object.keys(routes).find(r => r.split('*')[0] === basePath)) {
            return navigate(hasToken ? page ? `/${page}` : "/home" : "/login");
        }

        if (isProtectedPath && hasToken) {

            const admin = handleAdminRole();
            handleInitialData();

            const handled = handleAdminRoute(pagePath, admin);

            if (!handled) {
                TagManager.sendVirtualPageView(`${window.location.origin}${pagePath}`);
            }

            if (page) {
                navigate(page ? `/${page}` : "/home");
            }
        }

    }, [handleAdminRole, handleInitialData, handleLogout, recaptchaRef]);

    return { handleRouteChange };
}

export default useProtectRoutes;